import { useEffect, useRef, useState } from 'react';
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { autoCompleteDelay } from "../../config";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FetchAutoCompleteData, FindTranslatedKey, arraysAreEqual } from "../CommonComponents/CustomHooks";
import { AutoCompleteBox, FormButton, InputBox, SelectInputBox } from '../CommonComponents/InputBox';
import { OperationalTable } from '../CommonComponents/OperationalTable';
const AssignPickupRequest = () => {
    const dispatch = useDispatch();
    const inputrefs = useRef([])
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [tableData, setTableData] = useState([])
    const [prevTableData, setPrevTableData] = useState([])
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [checkAll, setCheckAll] = useState(false);
    const [scanNo, setScanNo] = useState('')
    const [formData, setFormData] = useState({
        awbNo: '',
        vehicleNo: '',
        vehicleType: '',
        driver: '',
        assignPickupBy: '',
        thirdParty: '',
        totalPickUp: '',
        awbNoList: []
    });
    const handleClear = () => {
        setFormData({
            awbNo: '',
            vehicleNo: '',
            vehicleType: '',
            driver: '',
            assignPickupBy: '',
            thirdParty: '',
            totalPickUp: '',
            awbNoList: []
        });
        GetAssignPickupRequest()
        inputrefs.current['txtAssignPickupBy'].focus();
    }
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };
    const AssignPickupRequest = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Operation/AssignPickup', { ...formData, awbNo: (formData.awbNoList).toString() })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    }

    const GetAssignPickupRequest = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",

        }
        setIsLoading(true)
        let data = await ApiCall('/api/Operation/AssignPickupRequest', GetData)
        setTableData(data)
        setPrevTableData(data)
        setIsLoading(false)
        if (data.Status === 'ERROR' || data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const getSacnDataSearch = async (value, CurrentPage) => {
        //  let PageIndex = 1
      
        let GetData = {
            ...sortConfig,
            // "PageIndex": PageIndex.toString(),
            "Type": "S",
            SearchText: value ? value : []

        }
        setIsLoading(true)
        let data = await ApiCall('/api/Operation/AssignPickupRequest', GetData)

     
        if (data.Status === 'SUCCESS') {
            setTableData(prev => ({
                ...prev, Data: [...data.Data,
                ...prevTableData.Data.filter(
                    item => !data?.Data?.some(d => d.ReferenceNo === item.ReferenceNo)
                )]
            }
            ))
            setPrevTableData(prev => ({
                ...prev, Data: [...data.Data,
                ...prevTableData.Data.filter(
                    item => !data?.Data?.some(d => d.ReferenceNo === item.ReferenceNo)
                )]
            }
            ))
            setIsLoading(false)
        }

        setIsLoading(false)
        if (data.Status === 'ERROR' || data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const handleCheck = (id, awbNo) => {
        const updatedAwbNoList = [...formData.awbNoList];
        const index = updatedAwbNoList.indexOf(awbNo);

        if (index !== -1) {
            updatedAwbNoList.splice(index, 1);
        } else {
            updatedAwbNoList.push(awbNo);
        }
        setFormData({ ...formData, awbNoList: updatedAwbNoList });
    };

    const handleCheckAll = (value) => {
        setCheckAll(value);
        const updatedTableData = tableData?.Data.map(item => {
            return {
                ...item,
                checkStatus: value
            };
        });
        setTableData(prevCNResult => ({
            ...prevCNResult,
            Data: updatedTableData
        }));
        const updatedAwbNoList = value ? tableData?.Data.map(item => item.ReferenceNo) : [];
        setFormData({
            ...formData, awbNoList: updatedAwbNoList,
        });
    };

    const HandleScanData = async () => {
        if (!scanNo) {
            await NotificationSound('ERROR', 'Enter the Ref No.', 'txtAwbNo', inputrefs);
            return;
        } else {
            let isRefNoExists = tableData.Data?.filter(d => d.ReferenceNo === scanNo && d.checkStatus).length > 0;
            if (isRefNoExists) {
                await NotificationSound('ERROR', 'Ref No. already scanned', 'txtAwbNo', inputrefs);
                return;
            }
            let tableData1 = tableData.Data.map(item => {
                if (scanNo === item.ReferenceNo) {
                    return {
                        ...item,
                        checkStatus: true
                    }
                } else {
                    return {
                        ...item,
                        checkStatus: item.checkStatus ? item.checkStatus : false
                    }
                }
            })
            setScanNo('')
            const updatedList = [...tableData1.filter(item => item.checkStatus && item.ReferenceNo !== scanNo).map(item => item.ReferenceNo), scanNo] || [];
        
            setFormData({ ...formData, awbNoList: [...updatedList], awbNo: updatedList.join() })
            getSacnDataSearch(scanNo)


        }
    }

    useEffect(() => {
        let newTableData = tableData?.Data?.map(item => {
            const checkStatus = formData?.awbNoList.some(awb => item.ReferenceNo === awb) ? true : false;
            return { ...item, checkStatus };
        });
        setFormData(prevFormData => ({
            ...prevFormData,
            totalPickUp: (prevFormData?.awbNoList?.length).toString()
        }));
        if (!arraysAreEqual(newTableData, tableData.Data)) {
            setTableData(prevTableData => ({
                ...prevTableData,
                Data: newTableData,
                HideColumns: prevTableData?.HideColumns ? [...prevTableData?.HideColumns, 'checkStatus', 'Checkbox'] : ['checkStatus', 'Checkbox']
            }));
        }
    }, [tableData.Data, formData.awbNoList]);


    const autoCompleteTimeoutRef = useRef(null);
    const handleAutoCompleteChange = async (event, newValue, field, type) => {
        if (autoCompleteTimeoutRef.current) {
            clearTimeout(autoCompleteTimeoutRef.current);
        }
        if (event?.type === 'change') {
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData('', newValue, type, field);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay)
        }
    };

    const handleClick = (value) => {      
        //window.open(`/UpdatePickUpRequest?AwbNo=${value.trim()}`, '_blank');
        window.open(`/PickUpRequest?AwbNo=${value.trim()}&PageType=UPD`);

    }

    const handleChange1 = (event, value) => {
        GetAssignPickupRequest(value);
    };
    useEffect(() => {
        GetAssignPickupRequest()
    }, [sortConfig])

    useEffect(() => {
        document.title = 'Assign Pickup Request'
        inputrefs.current['txtAssignPickupBy'].focus()

    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <span className="fs-6 fw-bold headingspan"> {FindTranslatedKey('Assign Pickup Request')}</span>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>
                            <SelectInputBox
                                label='Assign Pickup By'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtAssignPickupBy'
                                value={formData.assignPickupBy}
                                onChange={(e) => {
                                    setFormData({ ...formData, assignPickupBy: e.target.value, driver: '', thirdParty: '' })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        if (formData.assignPickupBy === 'Driver') {
                                            inputrefs.current['txtDriver'].focus()
                                        }
                                        else if (formData.assignPickupBy === 'ThirdParty') {
                                            inputrefs.current['txtThirdParty'].focus()
                                        }
                                    }
                                }}
                            >
                                <option value=''>{`--${FindTranslatedKey('Select')}--`}</option>
                                <option value='Driver'>{FindTranslatedKey('Driver')}</option>
                                <option value='ThirdParty'>{FindTranslatedKey('Third Party')}</option>

                            </SelectInputBox>
                            {formData.assignPickupBy === 'Driver' ? <>
                                <AutoCompleteBox
                                    label='Driver'
                                    placeholder='Driver'
                                    inputValue={formData.driver}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, '', 'GetDriver');
                                            setFormData({ ...formData, driver: newInputValue })
                                        }
                                    }
                                    inputrefs={inputrefs}
                                    id='txtDriver'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtVehicleNo'].focus()
                                        };
                                    }}
                                    required={true}
                                />

                            </> : <>{formData.assignPickupBy === 'ThirdParty' ? <>

                                <AutoCompleteBox
                                    label='Third Party'
                                    placeholder='Third Party'
                                    inputValue={formData.thirdParty}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, '', 'GetVendor');
                                            setFormData({ ...formData, thirdParty: newInputValue })
                                        }
                                    }
                                    inputrefs={inputrefs}
                                    id='txtThirdParty'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtVehicleNo'].focus()
                                        };
                                    }}
                                    required={true}
                                />

                            </> : <></>}</>}
                            <InputBox
                                id="txtVehicleNo"
                                label='Vehicle No'
                                PlaceHolderText='Vehicle No'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtVehicleType'].focus()
                                    }
                                }}
                                required={false}
                                inputrefs={inputrefs}
                                value={formData.vehicleNo}
                                onChange={(e) => setFormData({ ...formData, vehicleNo: e.target.value })}
                            />
                            <InputBox
                                id="txtVehicleType"
                                label='Vehicle Type'
                                PlaceHolderText='Vehicle Type'
                                name='Vehicle Type'
                                required={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['btnSub'].focus()
                                    }
                                }}
                                inputrefs={inputrefs}
                                value={formData.vehicleType}
                                onChange={(e) => setFormData({ ...formData, vehicleType: e.target.value })}
                            />



                            <InputBox
                                id="txtTotalPickUp"
                                label='Total Pickup'
                                required={true}
                                disabled
                                PlaceHolderText="Total Pickup"
                                value={formData.totalPickUp}
                                inputrefs={inputrefs}

                            />
                        </div>
                    </div>
                    <div className='card-body'>
                        <FormButton
                            id={'btnSub'}
                            inputrefs={inputrefs}
                            Export={false}
                            handleSubmit={AssignPickupRequest}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>

            <OperationalTable
                PageName={'AssignPickupRequest'}
                inputPlaceHolder='Ref No'
                showCheckBox={true}
                Filter={false}
                loading={isLoading}
                handleCheck={handleCheck}
                handleCheckAll={handleCheckAll}
                CheckAll={checkAll}
                currentPageNo={currentPageNo}
                tableData={tableData}
                cnNo={scanNo}
                setcnNo={setScanNo}
                HandleScanList={HandleScanData}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
                handleChange1={handleChange1}
                matchingkey={'ReferenceNo'}
                ClickOnLink={handleClick}
            />
        </>
    )
}
export default AssignPickupRequest;
